

<!-- header end -->

<!-- body -->
<!-- basecamp -->

<sm-title-bar  pageTitle="Contact us">
</sm-title-bar>
<div class="contact_lookzup">
  <div>
      <div class="row">
          
          <div class="col-sm-12 col-md-12 col-12" *ngIf="!contactUsFlag">

              <div class="contact_flied">
                <mat-card appearance="outlined">
                  <div class="message_heading">
                    <h3>Send a quick message to us
                    </h3>
                    <p>You can drop a message for us here. It can be of various types, primarily related to troubleshooting and resolving
                       issues with a product, service, or system. Or for creating your brand with custom app and website.</p>
             </div>

             <div class="frm_kp">
             <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>
                <input matInput type="text" placeholder="Enter your name" [(ngModel)]="name">
              </mat-form-field>
            </div>

         

                <div class="c_sectionmj">
                    <div class="row">
                     <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="country-code">
                        <mat-label>Country Code</mat-label>
                        <mat-select
                        [(ngModel)]="selectedCountryCode"
                        required
                        (selectionChange)="onCountrySelected($event)"
                      >
                        <mat-select-trigger>
                          {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                              {{ "(" + selectedCountryCode.dial_code + ")" }}
                        </mat-select-trigger>
                        
                        <mat-option>
                          <ngx-mat-select-search
                            noEntriesFoundLabel="no results found"
                            name="countrysearch"
                            
                            [formControl]="searchString"
                            (keyup)="onKey()"
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let country of countryList" [value]="country">
                          {{ country.flag }} {{ country.name }}
                          {{ "(" + country.dial_code + ")" }}
                        </mat-option>
                      </mat-select>
                      </mat-form-field>
                   </div>
                   <div class="col-sm-9">
                     <mat-form-field appearance="outline" class="phone-number">
                       <mat-label>Phone</mat-label>
                       <input matInput  type="tel" [(ngModel)]="phone" minlength="3" maxlength="17">
                     </mat-form-field>
                     </div>
                   </div>
                   </div>

                <div class="frm_kp">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Email</mat-label>
                  <input matInput type="text"  [(ngModel)]="email">
                </mat-form-field>
                </div>

                <div class="frm_kp">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Subject</mat-label>
                  <input matInput type="text"  [(ngModel)]="subject">
                </mat-form-field>
                </div>

                <div class="frm_kp">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Message</mat-label>
                    <textarea matInput  [(ngModel)]="message"></textarea>
                  </mat-form-field>
                  </div>
                  <div class="checkbox_part">
                    <!-- <div class="row">
                      <div class="col-sm-3">
                        <mat-checkbox [(ngModel)]="problemData[0]" class="trga">Issue/Bug Reporting</mat-checkbox>
                      </div>
                      <div class="col-sm-3">
                        <mat-checkbox [(ngModel)]="problemData[1]" class="trga">Feature Request</mat-checkbox>
                      </div>
                      <div class="col-sm-2">
                        <mat-checkbox [(ngModel)]="problemData[2]" class="trga">Feedback</mat-checkbox>
                      </div>
                      <div class="col-sm-2">
                        <mat-checkbox [(ngModel)]="problemData[3]" class="trga">Testimonial</mat-checkbox>
                      </div>
                      <div class="col-sm-2">
                        <mat-checkbox [(ngModel)]="problemData[4]" class="trga">Others</mat-checkbox>
                      </div>
                    </div> -->
                    <div class="support_sef">
                      <mat-chip-listbox>
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[0]}" selectable="false" (click)="clickChip(0)">
                          <mat-icon *ngIf="problemData[0]">check</mat-icon> Issue/Bug Reporting
                        </mat-chip>
                        <mat-chip class="open_rrt activeb" [ngClass]="{'activeb': problemData[1]}" selectable="false" (click)="clickChip(1)">
                          <mat-icon *ngIf="problemData[1]">check</mat-icon> Feature Request
                        </mat-chip>
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[2]}" selectable="false" (click)="clickChip(2)">
                          <mat-icon *ngIf="problemData[2]">check</mat-icon> Feedback
                        </mat-chip>
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[3]}" selectable="false" (click)="clickChip(3)">
                          <mat-icon *ngIf="problemData[3]">check</mat-icon> Testimonial
                        </mat-chip>
                      
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[4]}" selectable="false" (click)="clickChip(4)">
                          <mat-icon *ngIf="problemData[4]">check</mat-icon> Others
                        </mat-chip>
                      </mat-chip-listbox>
                    </div>
                    
                  </div>
                  
                  <div class="cabh_sect">
                    <button mat-flat-button class="cccakl" >Clear</button>
                    <button mat-flat-button color="accent" class="submit-btn" (click)="sendContactUs()" [disabled]="!name || !phone || !subject || !message || checkForm() || phone.length < 3"  >Submit</button>
                </div>
                </mat-card>
              </div>
          </div>
          <div class="col-sm-12 col-md-12 col-12" *ngIf="contactUsFlag">
            <div class="contact_flied alt_contact" style="height: 447px;">
              <div style="text-align: center;" class="padf_contact">
                <div class="sdvbtg_sdsf">
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 682.667 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><defs><clipPath id="b" clipPathUnits="userSpaceOnUse"><path d="M0 512h512V0H0Z" fill="#828282" opacity="1" data-original="#000000"></path></clipPath></defs><mask id="a"><rect width="100%" height="100%" fill="#ffffff" opacity="1" data-original="#ffffff"></rect></mask><g mask="url(#a)"><g clip-path="url(#b)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="M0 0h-38.255v-169.01H0a9.564 9.564 0 0 1 9.564 9.565V-9.563C9.564-4.283 5.282 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(259.686 195.815)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-5.988 0-10.841-4.854-10.841-10.842v-147.325c0-5.988 4.853-10.843 10.841-10.843h37.418V0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(184.013 195.815)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-64.661" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(472.588 136.317)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-52.195" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(460.123 96.507)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-43.418" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(451.346 56.696)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-264.071c-17.565 0-31.937-14.372-31.937-31.937v-158.47c0-17.566 14.372-31.938 31.937-31.938h28.503c4.213 0 8.094-2.287 10.134-5.973l27.011-48.801c2.345-4.236 8.435-4.236 10.779 0l27.634 49.925a9.402 9.402 0 0 0 8.228 4.849h21.43v35.623c0 5.989 4.853 10.842 10.842 10.842 2.095 0-2.086 0 0 0h75.673c5.282 0 9.564-4.283 9.564-9.563v-10.126h16.458c15.293.158 24.296 6.663 24.296 7.785A151.824 151.824 0 0 1 28.31-159.92l3.627 6.011v121.972C31.937-14.372 17.565 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(303.523 371.695)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-9.073 0-16.486 7.399-16.486 16.486 0 10.42 9.594 18.202 19.717 16.156 7.355-1.391 13.255-8.045 13.255-16.156C16.486 7.427 9.133 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(98.97 244.724)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-9.073 0-16.486 7.399-16.486 16.486 0 10.42 9.594 18.202 19.717 16.156 7.355-1.391 13.255-8.045 13.255-16.156C16.486 7.427 9.133 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(168.19 244.724)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-9.073 0-16.486 7.399-16.486 16.486 0 10.42 9.594 18.202 19.717 16.156 7.355-1.391 13.255-8.045 13.255-16.156C16.486 7.427 9.133 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(237.412 244.724)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h36.431c10.792 0 19.985 8.39 20.373 19.175.407 11.323-8.654 20.633-19.892 20.633h8.296c10.792 0 19.984 8.39 20.37 19.174.405 11.326-8.653 20.636-19.889 20.636h11.99c10.791 0 19.982 8.39 20.367 19.174.405 11.325-8.653 20.637-19.891 20.637h11.991c11.235 0 20.294 9.305 19.892 20.63-.384 10.786-9.576 19.179-20.37 19.179H-9.78c-11.86 0-20.23 11.622-16.472 22.87l17.556 50.376c4.658 13.366-2.619 27.942-16.1 32.251a17.432 17.432 0 0 1-20.232-7.596l-37.573-62.252a151.868 151.868 0 0 0-21.828-27.865c0-1.122-9.003-7.626-24.296-7.784h-16.459V28.555h19.822C-96.543 28.555-99.184 0-63.33 0H-35" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(414.434 16.889)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0v.001l-2.081-3.448Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(335.46 217.786)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c42.078 31.966 88.615 81.683 94.964 148.002" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(405.53 248.774)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-8.84 36.222-41.471 63.129-80.418 63.166-30.931.031-57.896-16.895-72.158-41.989l-.012.004c-6.079-7.51-15.433-7.528-21.528.021l-.006-.007c-14.209 25.13-41.14 42.111-72.069 42.14-45.781.046-82.932-37.024-82.977-82.802a160.537 160.537 0 0 1 5.172-40.614" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(498.857 431.776)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0v0c.44.696.889 1.388 1.318 2.092l1.547 2.563-1.547-2.563C.889 1.389.44.697 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(330.515 209.684)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path></g></g></g></svg>
                </div>
                <h3 style="    font-size: 24px;
                font-weight: 500;
                margin-bottom: 10px;
                margin-top: 20px;
                color: #222;">Thanks for your feedback.</h3>
                <p style="color: #464646;">Our support team will connect with you via the contact information you provided.</p>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-12">
            <div class="contact_us_feed">
            <div class="frm_lookz_cotact">
                <div class="p-a30  m-b30 contact-area">
                    <h4 class="m-b10">Quick Connect</h4>
                    <p>If you have any query or question, contact us via physical mail, email or a phone call.</p>
                    <ul class="no-margin">
                        <li class="icon-bx-wraper left m-b30">
                            <div class="icon-bx-xs border-1">
                                <i class="fab fa-map-marker-alt"></i>
                            </div>
                            <div class="icon-content">
                                <h6 class="text-uppercase m-tb0 dlab-tilte">Address:</h6>
                                <p>Logicasana Pvt. Ltd. <br>
                                  2, Jessore Road, Golpark, Dumdum, 
                                  Kolkata, India, Pin- 700028.</p>
                            </div>
                        </li>
                        <li class="icon-bx-wraper left  m-b30">
                            <div class="icon-bx-xs border-1">
                                <i class="fab fa-envelope"></i>
                            </div>
                            <div class="icon-content">
                                <h6 class="text-uppercase m-tb0 dlab-tilte">Email:</h6>
                                <p>info&#64;lookzup.com <br>
                                  support&#64;lookzup.com</p>
                            </div>
                        </li>
                        <li class="icon-bx-wraper left">
                            <div class="icon-bx-xs border-1">
                                <i class="far fa-phone"></i>
                            </div>
                            <div class="icon-content">
                                <h6 class="text-uppercase m-tb0 dlab-tilte">PHONE:</h6>
                                <p class="marginbt">+91 9147080470 <br> +91 9147080471</p>
                            
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        </div>
      </div>

<div class="support_list_social">
     
          <div class="list_fbs">
            <a href="https://www.facebook.com/lookzupapp" target="_blank">
            <i class="fab fa-facebook" aria-hidden="true"></i>
          </a>
          </div>
          <div class="list_fbs">
            <a href="https://twitter.com/lookzup" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 1226.37 1226.37" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M727.348 519.284 1174.075 0h-105.86L680.322 450.887 370.513 0H13.185l468.492 681.821L13.185 1226.37h105.866l409.625-476.152 327.181 476.152h357.328L727.322 519.284zM582.35 687.828l-47.468-67.894-377.686-540.24H319.8l304.797 435.991 47.468 67.894 396.2 566.721H905.661L582.35 687.854z" fill="#9b9b9b" opacity="1" data-original="#000000" class=""></path></g></svg>
            </a>
          </div>
          <div class="list_fbs">
            <a href="https://www.instagram.com/lookzup.app/" target="_blank">
            <i class="fab fa-instagram " aria-hidden="true"></i>
          </a>
          </div>
          <div class="list_fbs">
            <a href="https://youtube.com/@lookzup" target="_blank">
            <i class="fab fa-youtube"></i>   
            </a>
                 </div>
    </div>
  </div>
</div>



<!-- body -->

<!-- Footer start -->
<!-- footer  -->

<!-- footer end -->

<script src=".././assets/js/jquery-1.12.4.min.js"></script>
<script src=".././assets/js/popper.min.js"></script>
<script src=".././assets/js/bootstrap.min.js"></script>
<script src=".././assets/js/modernizr-3.5.0.min.js"></script>
<script src=".././assets/js/jquery.meanmenu.min.js"></script>
<!-- ma5menu -->
<!-- <script src="assets/js/ma5-menu.min.js"></script> -->
<script src=".././assets/pluging/owl.carousel.min.js"></script>
<script>
    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    })
</script>
<script>
    $(function() {
        $(".dropbtn ").click(
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeIn("fast ");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up ");
            },
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeOut("fast ");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up ");
            });
    });
</script>
<script>
    // meanmenu
    $('#mobile-menu').meanmenu({
        meanMenuContainer: '.mobile-menu',
        meanScreenWidth: "992 "
    });

    $('.info-bar').on('click', function() {
        $('.extra-info').addClass('info-open');
    })

    $('.close-icon').on('click', function() {
        $('.extra-info').removeClass('info-open');
    })
</script>
<!-- Call the script -->
<script>
    $(document).ready(function() {
        ma5menu({
            menu: '.site-menu',
            activeClass: 'active',
            position: 'left',
        });
    });
</script>
